// extracted by mini-css-extract-plugin
module.exports = {"reasonForDelete":"DeleteScheduleDialog_reasonForDelete__epTC-"};